// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__+ae-a","description":"MealItem_description__SuWO-","price":"MealItem_price__oo8YT"};